module.exports = __webpack_public_path__ + "img/payme.865a8543.jpg";